import { useDesktopView } from 'utils/hooks/useDesktopView'

export const usePolicyTnsDesktopView = () =>
  useDesktopView('policy-tns-desktop-view-enabled')
